// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"D8-z","refreshPageWarning":"E8-z","redirectMessageText":"F8-z"};